export default __webpack_public_path__ + "static/media/flying.d1778503.svg";